import type { MessageType } from "@lib/campaignMessageTypeConstants";

import { pushPlatformsIn } from "./pushPlatformsIn";

/**
 * Whether duplicate-as-CO should assign `composition_mode: "per-variation"` on the clone.
 * True when exactly one push platform is copied; quick-push modes need two or more push rows on CO hotdog.
 */
export const shouldSetPerVariationCompositionOnDuplicate = (
  selectedMessageTypes: readonly (MessageType | null | undefined)[]
): boolean => pushPlatformsIn(selectedMessageTypes).size === 1;
